<template>
  <span class="fav-btn-base">
    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg" @click.stop="onHeartClick">
      <path
        d="M8.44444 3.38333C8.44444 3.38333 9.55556 1.10833 12.1111 1.10833C14.6667 1.10833 16 3.275 16 5.225C16 7.175 14.7778 9.55833 8.55556 14C3.22222 10.425 1 7.5 1 5.11667C1 3.275 2.22222 1 4.66667 1C7.22222 1.10833 8.44444 3.38333 8.44444 3.38333Z"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        :stroke="buttonColor"
        :fill= "fillColor"
      />
    </svg>
    <span><span class="fav-num">{{favNum}}</span></span>
  </span>
</template>

<script>
export default {
  name: 'FavButton',
  data(){
    return {
      buttonColor: '#ff7497',
      blankColor: 'transparent',
      fillColor: ''
    }
  },
  props: {
    favStatus: {
      type: Boolean,
      default() {
        return false
      }
    },
    favNum: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  watch: {
    favStatus(val) {
      this.setStatus()
    }
  },
  created() {
    this.setStatus()
  },
  methods: {
    onHeartClick(){
      this.$emit('fav-click')
    },
    setStatus(){
      if(this.favStatus) {
        this.fillColor = this.buttonColor
      }else{
        this.fillColor = this.blankColor
      }
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.fav-btn-base {
  display: flex;
  align-items: center;
  height: fit-content;

  svg {
    line-height: 1;
    vertical-align: middle;
  }
  .fav-num {
    line-height: 1;
    margin-left: 5px;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/FavButton.vue